import React, {useRef} from "react";
import HubspotForm from 'react-hubspot-form';
import {useI18next, useTranslation} from 'gatsby-plugin-react-i18next';

export const SubscribeFormNew = () => {
  const hubspotFormRef = useRef(null);
  const {t} = useTranslation();
  const {language} = useI18next();

  return (
    <HubspotForm
      locale={language}
      ref={hubspotFormRef}
      portalId='2784460'
      formId='b9c8942f-091c-42c4-9c3d-6ab62db88b03'
      cssClass="position-relative subscribe-form"
      submitButtonClass="btn btn-white position-absolute subscribe-form__btn"
      loading={<div>{t("Loading...")}</div>}
    />
  )
}
